skrilla.directive('promotionClaims',function() {
    return {
        templateUrl: 'directives/promotionClaims/promotionClaims.html',
        scope: {
            codeId: "=",
            code: "="
        },
        controller: function($scope, searchService, paginationService, queryService){
            $scope.pageKey = "promotionClaims" + $scope.codeId;

            $scope.reset = function() {
                $scope.query = {
                    codeId: $scope.codeId,
                    code: $scope.code,
                    limit: 20
                }
            }
            $scope.reset();

            $scope.paidStatuses = [
                "PENDING",
                "PAID",
                "DECLINED"
            ]

            $scope.search = function () {
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getClaims, $scope.pageKey);
            }

            const getClaims = function () {
                return searchService.get("promotions/claims" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
                    $scope.claims = response.data.result;
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }
        }
    };
});
